import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-navbar-licencas',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit {
  @Output() confirmarAlteracao: EventEmitter<boolean>  = new EventEmitter<boolean>();
  public nomeUsuario: string = ''

  ngOnInit(): void {
    this.nomeUsuario = this.buscarNomeLocalStorage();  
  }

  public confirmar(): void {
    this.confirmarAlteracao.emit(true);
  }

  public buscarNomeLocalStorage(): string {
    return localStorage.getItem('usuarioNome')!.split(' ')[0];
  }
}
